import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "../components/AuthShell";
import { Button, Input } from "../components/ui";
import { publicApi, apiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await publicApi.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset password" subtitle="We'll email you a link to reset it."
      footer={<Link to="/login" className="text-primary font-bold">← Back to sign in</Link>}>
      {sent ? (
        <div className="bg-primary/10 border-2 border-primary/20 rounded-3xl p-6 text-center" data-testid="forgot-sent">
          <p className="font-bold text-ink">Request received. If an eligible account exists for <span className="text-primary-dark">{email}</span>, we'll attempt to email a reset link.</p>
          <p className="text-sm text-ink-soft mt-2 font-medium">Check your inbox and spam folder. If it doesn't arrive, try again later or contact support.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required data-testid="forgot-email" />
          <Button type="submit" size="lg" className="w-full" disabled={loading} data-testid="forgot-submit">
            {loading ? "Sending…" : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
